<template>
  <div class="modal">
    <div class="modal-window bg-light_gray">
      <img src="@/assets/images/btn-close.svg" @click="closeMobaku">
      <div class="text-center">
        <div>
          <div class="font-bold">
            モバイル空間統計® 人口マップ
          </div>
          <div class="text-sm pt-2">
            モバイル空間統計®人口マップは㈱ドコモ・インサイトマーケティングが提供するサービスです
          </div>
          <div class="text-sm pt-2">
            NTTドコモの携帯電話ネットワークの仕組みを利用し、日本の人口を確認できます。
          </div>
          <div class="text-sm pt-2">
            本サービスは集団の人数のみを表す人口統計情報であるため、お客様個人を特定することはできません。
          </div>
          <div class="pt-2">
            <a href="https://mobaku.jp/" class="break-all text-link" target="_blank">モバイル空間統計®公式サイト</a>
          </div>
          <div class="pt-2">
            <a href="https://www.nttdocomo.co.jp/utility/privacy/" class="break-all text-link" target="_blank">プライバシーポリシー</a>
          </div>
          <div class="pt-2">
            <a href="https://mobakumap.jp/about.html" class="break-all text-link" target="_blank">データ仕様について</a>
          </div>
          <div class="pt-2">
            <a href="https://policies.google.com/technologies/partner-sites?hl=ja" class="break-all text-link" target="_blank">Googleポリシーと規約</a>
          </div>
        </div>
        <div class="pt-2">
          <a class="button-primary block" @click="closeMobaku">
            <span class="block whitespace-no-wrap text-xs">閉じる</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  mounted() {
    let script = document.createElement('script')
    script.onload = () => {
      // this.$store.dispatch('googleMap/initDocomoMobaku')
      this.$store.dispatch('user/offFilterFromTag', "mobaku")
    }
    script.async = true
    script.src = 'https://jre-maas.mobakumap.jp/js/app.js'
    document.head.appendChild(script)
  },
  methods: {
    closeMobaku: function () {
      this.$store.dispatch('map/setShowDocomoMobaku', false)
    }
  }
}
</script>
